module.exports = __webpack_public_path__ + "img/agentstudio-2.0c8ab89e.jpg";